import { render, staticRenderFns } from "./layOut.vue?vue&type=template&id=5a8f210d&scoped=true&"
import script from "./layOut.vue?vue&type=script&lang=js&"
export * from "./layOut.vue?vue&type=script&lang=js&"
import style0 from "./layOut.vue?vue&type=style&index=0&id=5a8f210d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8f210d",
  null
  
)

export default component.exports